import { Result } from '../types';
import { API_ENDPOINTS } from '../config/apiConfig';
import { apiFetch } from '../config/apiClient';

class ResultService {
  private getHeaders(): HeadersInit {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    const token = localStorage.getItem('token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  }

  private getAuthHeader(): HeadersInit {
    const headers: HeadersInit = {};
    const token = localStorage.getItem('token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return headers;
  }

  async importCsv(file: File, schoolId: string): Promise<Result[]> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('schoolId', schoolId);
    formData.append('academicYear', '2025-26');

    const response = await apiFetch(`${API_ENDPOINTS.learningApi}/results/import`, {
      method: 'POST',
      headers: this.getAuthHeader(),
      credentials: 'include',
      body: formData,
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.message || 'Failed to import CSV');
    }

    return response.json();
  }

  async getResultsBySchool(schoolId: string): Promise<Result[]> {
    const response = await apiFetch(`${API_ENDPOINTS.learningApi}/results/school/${schoolId}`, {
      method: 'GET',
      headers: this.getHeaders(),
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch results');
    }

    return response.json();
  }

  async deleteResultsBySchool(schoolId: string): Promise<void> {
    const response = await apiFetch(`${API_ENDPOINTS.learningApi}/results/school/${schoolId}?academicYear=2025-26`, {
      method: 'DELETE',
      headers: this.getHeaders(),
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to delete results');
    }
  }
}

const resultService = new ResultService();
export default resultService;
